// Apertura/chiusura del form dentro un box "cta-panel" (componente condiviso,
// vedi assets/scss/_cta-panel.scss): usato dal "Parliamone" dell'archivio
// Servizi (template-parts/archivio-servizi/cta.php) e dal "Proponi una
// collaborazione" dell'archivio Collaborazioni & Brand
// (template-parts/archivio-collaborazioni/cta.php, riusato anche in fondo a
// single-progetti.php). Il titolo/testo/bottone (&__row) restano sempre
// visibili: il form si apre sotto con un'animazione in due tempi (altezza del
// box + comparsa a cascata dei campi), senza mai lasciare la pagina né aprire
// un vero dialog/overlay.
function initCtaPanelBox(box) {
    const formPanel = box.querySelector('[data-cta-panel="form"]');
    // Bottone unico che apre e chiude il form (vedi _cta-panel.scss): non
    // dentro formPanel, quindi resta nel DOM/visibile in entrambi gli stati.
    // Facoltativo: i template senza $bottone_testo non lo hanno.
    const toggleButton = box.querySelector("[data-cta-toggle]");

    if (!formPanel || !toggleButton) {
        return;
    }

    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const MORPH_MS = reducedMotion ? 0 : 550;

    let isOpen = false;
    let isAnimating = false;

    // Anima l'altezza del box da quella attuale a quella restituita da
    // getTargetHeight, eseguendo `mutate` a metà strada (dopo aver fissato
    // l'altezza di partenza, prima di leggere/applicare quella di arrivo).
    // `mutate` è anche il punto in cui open()/close() innescano le altre
    // transizioni CSS del pannello (comparsa/dissolvenza dei campi): partendo
    // dallo stesso reflow dell'animazione dell'altezza, le due animazioni
    // corrono in parallelo sulla stessa timeline invece che in sequenza (la
    // dissolvenza in chiusura durava 220ms *prima* che il box iniziasse a
    // restringersi, con un percettibile scatto/lag tra le due fasi).
    function morphHeight(mutate, getTargetHeight, onDone) {
        if (reducedMotion) {
            mutate();
            onDone();
            isAnimating = false;
            return;
        }

        const startHeight = box.offsetHeight;
        box.style.height = `${startHeight}px`;

        mutate();

        void box.offsetHeight; // forza il reflow prima di leggere/applicare la nuova altezza

        const targetHeight = getTargetHeight();
        box.style.transition = `height ${MORPH_MS}ms cubic-bezier(0.65, 0, 0.35, 1)`;
        box.style.height = `${targetHeight}px`;

        window.setTimeout(() => {
            box.style.transition = "";
            box.style.height = "auto";
            onDone();
            isAnimating = false;
        }, MORPH_MS);
    }

    function onKeydown(event) {
        if (event.key === "Escape") {
            close();
        }
    }

    function open() {
        if (isOpen || isAnimating) {
            return;
        }

        isOpen = true;
        isAnimating = true;
        toggleButton.setAttribute("aria-expanded", "true");

        morphHeight(
            () => {
                formPanel.hidden = false;
                box.classList.add("is-form-open");
            },
            () => box.scrollHeight,
            () => {}
        );

        const firstField = formPanel.querySelector('[name="nome"]');
        if (firstField) {
            // L'altezza sta ancora animando: sposta il focus solo a metà
            // transizione, quando il campo è già visibile e non "salta"
            // la pagina in un layout ancora in movimento.
            window.setTimeout(() => firstField.focus(), MORPH_MS / 2);
        }

        document.addEventListener("keydown", onKeydown);
    }

    function close() {
        if (!isOpen || isAnimating) {
            return;
        }

        isOpen = false;
        isAnimating = true;
        toggleButton.setAttribute("aria-expanded", "false");

        morphHeight(
            () => formPanel.classList.add("is-leaving"),
            // Altezza "chiusa" (solo &__row) derivata per sottrazione da
            // quella attuale, invece che misurata nascondendo/rimostrando
            // formPanel: quel toggle di display lo fa uscire e rientrare dal
            // render tree, il che riavvia l'animazione CSS d'ingresso
            // (cta-panel-in, anche sui singoli campi) — visibile come "i campi
            // scompaiono e rispuntano" prima della vera chiusura. Qui
            // formPanel resta sempre nel DOM/visibile: solo opacity/transform
            // cambiano (via .is-leaving), che non riavviano nulla.
            () => {
                const formMarginTop = parseFloat(getComputedStyle(formPanel).marginTop) || 0;
                return box.scrollHeight - formPanel.offsetHeight - formMarginTop;
            },
            () => {
                formPanel.hidden = true;
                formPanel.classList.remove("is-leaving");
                box.classList.remove("is-form-open");
            }
        );

        toggleButton.focus();
        document.removeEventListener("keydown", onKeydown);
    }

    toggleButton.addEventListener("click", () => (isOpen ? close() : open()));
}

export function initCtaPanel() {
    document.querySelectorAll("[data-cta-box]").forEach(initCtaPanelBox);
}
